import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import Store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight, faAngleLeft, faSortDown, faMapMarkerAlt, faBed, faUserFriends, faPlusCircle, faUser, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import HeaderAlianca from './components/header-alianca.vue'
import FaleConosco from './components/FaleConosco.vue'
import DadosProposta from './components/Dados-proposta.vue'
import TermoLGPD from './components/TermoLGPD.vue'
import ModalAbandonoPagina from './components/ModalAbandonoPagina.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import Autocomplete from 'vuejs-auto-complete'
import DatePicker from 'vue2-datepicker'
import vmask from 'v-mask'
import VueTheMask from 'vue-the-mask'
import VueGtm from '@gtm-support/vue2-gtm';

import { ToggleButton } from 'vue-js-toggle-button'
 
library.add(faAngleRight, faAngleLeft, faSortDown, faMapMarkerAlt, faBed, faUserFriends, faPlusCircle, faUser, faDollarSign)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('header-alianca', HeaderAlianca)
Vue.component('FaleConosco', FaleConosco)
Vue.component('dados-proposta', DadosProposta)
Vue.component('termo-lgpd', TermoLGPD)
Vue.component('VueSlider', VueSlider)
Vue.component('Autocomplete', Autocomplete)
Vue.component('date-picker', DatePicker)
Vue.component('ToggleButton', ToggleButton)
Vue.component("modal-abandono-pagina", ModalAbandonoPagina);

Vue.config.productionTip = false
Vue.use(VueTheMask)
Vue.use(vmask)
Vue.use(
  VueGtm, {
    id: "GTM-KRJKD4N",
    vueRouter: router, 
})

Vue.use(
  VueGtm, {
    id: "GTM-KRJKD4N",
    vueRouter: router, 
})

Vue.use(
  VueGtm, {
    id: "GTM-KRJKD4N",
    vueRouter: router, 
})

new Vue({
  router,
  Store,
  render: h => h(App)
}).$mount('#app')
